import type { LucideIcon } from "lucide-react";

import { RectangleHorizontal, RectangleVertical, Square } from "lucide-react";

export type SizeItem = {
  label: string;
  size: string;
};

/** Preset deliverable sizes offered in the "Edit size" modal. */
export const SIZE_PRESETS: SizeItem[] = [
  { label: "Story", size: "1080×1920px" },
  { label: "Feed Portrait", size: "1080×1350px" },
  { label: "Feed Square", size: "1080×1080px" },
  { label: "Feed Landscape", size: "1080×566px" },
];

/** Pull the two leading numbers out of a size string like "1080×1920px". */
function parseDimensions(size: string): [number, number] | null {
  const nums = size.match(/\d+/g);

  if (!nums || nums.length < 2) return null;

  return [Number(nums[0]), Number(nums[1])];
}

/** Pick a frame icon from the aspect ratio (portrait / square / landscape). */
export function sizeIcon(size: string): LucideIcon {
  const dims = parseDimensions(size);

  if (!dims) return Square;
  const [width, height] = dims;

  if (height > width) return RectangleVertical;
  if (width > height) return RectangleHorizontal;

  return Square;
}

function digits(value: string): string {
  return value.replaceAll(/\D/g, "");
}

/** Loose match so presets already selected in the brief resolve back. */
export function sameSize(a: SizeItem, b: SizeItem): boolean {
  return digits(a.size) === digits(b.size);
}

/** Common deliverable file types offered in the edit modal. */
export const FILE_TYPE_PRESETS = [
  "PNG",
  "JPG",
  "PDF",
  "PSD/AI source files",
  "MP4",
];

export function sameFileType(a: string, b: string): boolean {
  return a.trim().toLowerCase() === b.trim().toLowerCase();
}
